<template>
  <div class="text-center text-xs">
    <h5>
      Por favor ingresa el código de confirmación que recibiste a tu celular
    </h5>
    <p>Por SMS</p>
  </div>
  <form @submit.prevent="validateCode" id="formCodigo">
    <div class="row px-3 my-4">
      <div class="form-group text-center">
        <div
          class="d-flex flex-row text-center gap-3 align-items-center justify-center col-sm-7 bg-white col-md-6 col-lg-10 col-xl-8 d-block mx-auto py-4 px-3 rounded-3"
        >
          <input
            type="tel"
            id="1"
            class="form-control text-center fw-bold"
            name="codigo1"
            autocomplete="off"
            maxlength="1"
            minlength="1"
            required
            @keyup="nextInput($event.target)"
          />
          <input
            type="tel"
            id="2"
            class="form-control text-center fw-bold"
            name="codigo2"
            autocomplete="off"
            maxlength="1"
            minlength="1"
            required
            @keyup="nextInput($event.target)"
          />
          <input
            type="tel"
            id="3"
            class="form-control text-center fw-bold"
            name="codigo3"
            autocomplete="off"
            maxlength="1"
            minlength="1"
            required
            @keyup="nextInput($event.target)"
          />
          <input
            type="tel"
            id="4"
            class="form-control text-center fw-bold"
            name="codigo4"
            autocomplete="off"
            maxlength="1"
            minlength="1"
            required
            @keyup="nextInput($event.target)"
          />
          <input
            type="tel"
            id="5"
            class="form-control text-center fw-bold"
            name="codigo5"
            autocomplete="off"
            maxlength="1"
            minlength="1"
            required
          />
        </div>
      </div>
      <div class="text-center mt-2 col-md-8 mx-auto">
        <button
          :disabled="btnLoading"
          class="btn bg-gradient-dark rounded-pill btn-lg w-100"
        >
          <span
            v-if="btnLoading"
            class="spinner-border spinner-border-sm me-1"
            role="status"
            aria-hidden="true"
          ></span>
          Continuar
        </button>
        <div class="">
          <button class="btn btn-link text-muted text-xs">
            No he recibido el código
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { useValidacionCodigo } from "@/composables/usePublic";
export default {
  setup() {
    const { btnLoading, validateCode, nextInput } = useValidacionCodigo();

    return {
      btnLoading,
      validateCode,
      nextInput,
    };
  },
};
</script>

<style></style>
